<template>
  <div class="storeage-log-container">
    <el-table :data="logs" height="100%">
      <el-table-column
        type="index"
        :align="align"
        width="50"
        label="序号"
      ></el-table-column>
      <el-table-column
        prop="operationUserName"
        :align="align"
        width="120"
        label="操作人"
      ></el-table-column>
      <el-table-column
        prop="operationTime"
        :align="align"
        width="180"
        label="操作时间"
      ></el-table-column>
      <el-table-column
        prop="deviceStatusShow"
        :align="align"
        width="120"
        label="操作设备"
      ></el-table-column>
      <el-table-column
        prop="operationTypeShow"
        :align="align"
        width="120"
        label="操作"
      ></el-table-column>
      <el-table-column
        prop="outStorageName"
        :align="align"
        width="120"
        label="仓库"
      >
        <template #default="{row}">
          {{row.inStorageName || row.outStorageName}}
        </template>
      </el-table-column>
      <el-table-column
        prop="comment"
        :align="align"
        label="备注"
      ></el-table-column>
    </el-table>
    <!-- <el-pagination layout="prev, pager, next, total" :total="1000"> </el-pagination> -->
  </div>
</template>

<script>
export default {
  props: {
    waybillSplitId: {},
    waybillNumber: {},
  },
  data() {
    return {
      align: "center",
      logs: [],
    };
  },
  watch: {
    waybillSplitId: {
      handler(val) {
        if (!val) {
          this.logs = [];
        }
        this.getData();
      },
    },
  },
  mounted(){
    this.getData()
  },
  methods:{
    //  出入库记录
    getData() {
      if(!this.waybillSplitId){
        return;
      }
      this.$API
        .wtl_getWaybillStockRecord({
          waybillSplitId: this.waybillSplitId,
        })
        .then((res) => {
          this.logs = res.data.result || [];
        });
    },
  }
};
</script>

<style scoped lang="less">
.storeage-log-container {
  height: 100%;
  display: flex;
  flex-flow: column;
}
</style>